import { useEffect, useMemo } from "react";
import olFeature from "ol/Feature";
import olVectorSource from "ol/source/Vector";
import { Style, Stroke } from "ol/style";
import { Vector } from "../../../../../reactOL/layers/Vector";
import { useFeatureContext } from "../../../../../../context/Feature";

interface SelectedOrderItemInrixVolumeLayerProps {
  visible: boolean;
}

const selectedOrderItemInrixVolumeStyle = new Style({
  stroke: new Stroke({
    color: "#ff9800",
    width: 4,
    lineCap: "round",
    lineJoin: "round",
  }),
});

const SelectedOrderItemInrixVolumeLayer = ({
  visible,
}: SelectedOrderItemInrixVolumeLayerProps) => {
  const { selectedFeatures } = useFeatureContext();
  const selectedGeometry = selectedFeatures[0]?.getGeometry() ?? null;

  const source = useMemo(() => new olVectorSource(), []);

  useEffect(() => {
    source.clear();
    if (!selectedGeometry) {
      return;
    }

    source.addFeature(
      new olFeature({
        geometry: selectedGeometry,
      }),
    );
  }, [selectedGeometry, source]);

  return (
    <Vector
      name="selected-order-item-inrix-volume"
      source={source}
      style={selectedOrderItemInrixVolumeStyle}
      zIndex={10001}
      visible={visible && selectedGeometry !== null}
    />
  );
};

export default SelectedOrderItemInrixVolumeLayer;
